class BaseController {
    /*ngInject*/
    constructor($mdSidenav, auth, $scope, $rootScope, $state) {
        "ngInject";
        _.extend(this, {
            $mdSidenav: $mdSidenav,
            $scope: $scope,
            auth: auth,
            $rootScope: $rootScope,
            $state: $state
        });

        /*
        * this is a fix for the next state to be mid scroll on its load. this listener reset the scroll on state change
        * */
        $rootScope.$on('$stateChangeSuccess', function() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        });

        $scope.$watch(
            () => {
                let user = this.auth.currentUser();
                return user ? user.name : false;
            },
            (user) => this.updateCurrentUser()
        );

    }

    toggleSideNav() {
        const menu = 'menu';
        this.$mdSidenav(menu)
            .toggle();
    }

    updateCurrentUser() {
        this.currentUser = this.auth.currentUser();
    }

    logout() {
        this.auth.logout();
    }

    goToBasicInfo() {
        this.$state.go('base.basic', {orderId: 'new'});
    }

    goToOrders() {
        this.$state.go('base.orders', {orderId: ''});
    }
}

export default BaseController;


// WEBPACK FOOTER //
// ./client/app/components/base/base.controller.js